import { compose } from 'redux'
import { connect } from 'react-redux'
import withReducer from '../Redux/withReducer'
import reducer from './reducer'
import { mapStateToProps } from './selector'
import { SessionReducer } from './container'

export default compose(
    withReducer(reducer),
    connect(mapStateToProps)
)(SessionReducer)
